<template>
  <div class="row small-gutters category-overview">
    <div
      v-for="category in sortedCategories" :key="category.name"
      class="col-12 col-sm-6 col-lg-4 mt-2 d-flex"
    >
      <router-link
        class="card category-overview--card"
        :class="{
          'query-active': keyword,
          'is-disabled': category.total <= 0 ,
          'highlight-background': keyword && !isLoading && category.total > 0
        }"
        :to="getCategoryLink(category)"
      >
        <h2 class="t-primary d-flex">
          <span class="category-icon-wrapper">
            <i class="fa t-secondary mt-1" :class="category.icon" />
          </span>
          <div class="ml-2 category-title">
            <span>{{ getIndexAsString(category.name) }}</span>
            <br class="d-none d-sm-block" />
            <div v-if="isLoading">
              <span class="pt-2 pb-1 v-spinner">
                <div class="v-pulse v-pulse1">
                </div><div class="v-pulse v-pulse2">
                </div><div class="v-pulse v-pulse3">
                </div>
              </span>
            </div>
            <span
              v-else
              :class="{
                't-secondary': !keyword || !category.total,
                't-blue': keyword && category.total
            }">{{ category.total | formatNumber}}</span>
          </div>
        </h2>
        <span class="category-extra-info">
          <div class="t-semi-compact pb-2 t-primary" v-html="category.description" />
          <div v-if="category.label" class="bg-yellow bd-radius px-2 py-1 t-white t-600 d-inline">{{ category.label }}</div>
        </span>
      </router-link>
    </div>
    <div class="col-12 col-md-12 col-lg-4 d-flex align-items-center p-4 mt-4">
      <span class="t-secondary t-sm t-semi-compact">
        If you don't find data that might be relevant for you, <a href="mailto:support@academiclabs.com" target="_blank" rel="noopener noreferrer">send us your request</a> and we'll see what we can do for you!
      </span>
     </div>
  </div>
</template>

<script>
import { ICONS } from '@/assets/js/_data'
import { getCategoryLink } from '@/plugins/utils'

const TIMESTAMP_EPOCH = 't'
const SORT_PARAM = 'sort'

export default {
  name: 'categoryOverview',
  props: {
    categories: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    keyword: {
      type: String,
      required: false
    },
    localKeyword: {
      type: String,
      required: false
    }
  },
  methods: {
    getCategoryLink (category) {
      const routeObject = getCategoryLink(this.searchView(category.name), this.$route, category.name)
      if (this.localKeyword) {
        routeObject.query = { keyword: this.localKeyword }
      }
      if (this.$route.query[TIMESTAMP_EPOCH]) {
        routeObject.query = {
          ...routeObject.query,
          [TIMESTAMP_EPOCH]: this.$route.query[TIMESTAMP_EPOCH],
          [SORT_PARAM]: 'last_added'
        }
      }
      return routeObject
    }
  },
  computed: {
    sortedCategories () {
      const categories = this.categories
      const sortable = []

      if (this.isEmpty(categories)) return sortable

      Object.entries(categories).forEach(([index, category]) => {
        category.name = index
        category.icon = ICONS[index]
        sortable.push(category)
      })

      return sortable.sort((a, b) => a.order - b.order)
    }
  }
}
</script>
